"use client"

import { StytchProvider, StytchClient, createStytchUIClient, PresentationConfig, defaultDarkTheme } from "@stytch/nextjs";
import ToastProvider from "./toastprovider";
import IntlProvider from "./intlprovider";

const stych: StytchClient = createStytchUIClient( process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN as string );

export const figtree = { className: 'font-figtree', style: { fontFamily: "'Figtree', sans-serif" } }

const baseTheme: PresentationConfig['theme'] = {
    ...defaultDarkTheme,
    background: '#231F20',
    border: 'rgba(255,255,255,0.25)',
    'container-border': '#231F20',
    primary: '#875719',
    'primary-foreground': '#FFFFFF',
    foreground: '#FFFFFF',
    secondary: '#FFFFFF',
    'secondary-foreground': '#000000',
    input: 'rgba(255, 255, 255, 0.3)',
    destructive: '#FB9A92',
    'font-family': figtree.style.fontFamily,
};

export const desktopPresentation: PresentationConfig = {
    theme: { ...baseTheme, 'container-width': '475px' },
    options: { hideHeaderText: false },
};

export const mobilePresentation: PresentationConfig = {
    theme: { ...baseTheme, 'container-width': '90vw' },
    options: { hideHeaderText: false },
};

export function Providers ({params, children}: { params: { lang: string }, children: React.ReactNode }) {

    return(
        <IntlProvider params={params}>
            <StytchProvider stytch={stych}>
                <ToastProvider>
                    {children}
                </ToastProvider>
            </StytchProvider>
        </IntlProvider>
    );
}
